import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const BackButton = ({ to, state, label = 'Back', className = '' }) => (
  <Link
    to={to}
    state={state}
    className={`btn btn-outline-secondary mb-2 ${className}`}
  >
    <FaArrowLeft /> &nbsp;{label}
  </Link>
);

export default BackButton;
